import React from 'react';
import PropTypes from 'prop-types';
import {
  IonContent,
  IonHeader,
  IonPage,
  IonTitle,
  IonToolbar,
  IonButtons,
  IonBackButton,
  IonGrid,
  IonRow,
  IonCol,
  IonSpinner
} from '@ionic/react';
import { connect } from 'react-redux'

import './Results.css';
import ResultActions from '../../../actions/result';
import ErrorAlert from '../../../components/ErrorAlert';

interface IProps {
  getChild: any;
  data: any;
}

interface IState {
  data: any;
  match: any;
}

class Results extends React.Component<IProps, IState> {
  constructor(props: any) {
    super(props)
    this.state = {data: props.data, match: props.match}
  }

  componentDidMount(){
    if(this.state.data.eva.length === 0){
      this.props.getChild({id: this.state.match.params.child}, "get_child");
    }
  }

  UNSAFE_componentWillReceiveProps(nextProps: any){
    this.setState({
      data: nextProps.data,
    });
  }

  render() {
    const { headers, ne, user, error401, error, loading } = this.state.data;
    return (
      <IonPage>
        <ErrorAlert/>
        <IonHeader>
          <IonToolbar color="primary">
            <IonTitle>{ !error && !error401 && user.alumno ? user.alumno : error || error401 ? "Error en la petición":"Cargando..." }</IonTitle>
            <IonButtons slot="start">
              <IonBackButton defaultHref="/progress" />
            </IonButtons>
          </IonToolbar>
          <IonToolbar className="toolbarTint">
            <IonTitle style={ !error && !error401 && user.alumno ? {display: "block"}: {display: "none"}} className="ion-text-center">IB: {user.grado} {user.seccion} - {user.turno}</IonTitle>
          </IonToolbar>
        </IonHeader>

        <IonContent fullscreen>
          <div style={ loading ? {display: "block", paddingTop: '10%'} : {display: "none"}} className="ion-text-center"><IonSpinner name="circles" color="primary"/></div>
          <h1 style={error || error401 && !loading ? {display: "block"} : {display: "none"}} className="ion-text-center">Error en el sistema, consulte con el administador de la aplicación.</h1>
          <h1 style={headers.length === 0 && !error && !error401 && !loading ? {display: "block"} : {display: "none"}} className="ion-text-center">No hay registros</h1>
          <IonGrid className="gridScroll" style={error || error401 && !loading ? {display: "none"} : {display: "block"} }>
            <IonRow className="rowScroll">
              {headers.map((h:any, key:any) => {
                return (
                  <IonCol key={key} className={ key === 0 ? "headerTable firstColumn": "headerTable"} style={ key === 1 ? { marginLeft: '44%' } : {textTransform: 'uppercase'}} size={key === 0 ? "5": key === headers.length-2 ? "3":"2"}>{h[0]}</IonCol>
                );
              })}
            </IonRow>
            {ne.map((val:any, key:any) => {
              return (
                <IonRow key={key} className="rowScroll">
                  {headers.map((valh:any, keyh:any) => {
                    if (keyh !== headers.length-1){
                      return (
                        <IonCol key={keyh} className={ keyh === 0 ? "rowTable firstColumn": "rowTable"} style={ keyh === 1 ? { marginLeft: '44%', height: '50px' } : {height: '50px'}} size={keyh === 0 ? "5": keyh === headers.length-2 ? "3":"2"}>{val[valh[0]]}</IonCol>
                      );
                    }else{
                      return (
                        <IonCol key={keyh} className="rowTable" style={ val[valh[0]] > 89 ? { backgroundColor: '#0db465', height: '50px', color: 'white' } : val[valh[0]] > 59 ? {height: '50px', backgroundColor: '#f9a602', color: 'white'} : {height: '50px', backgroundColor: '#eb445a', color: 'white'}} size="2">{val[valh[0]]}</IonCol>
                      );                    }
                  })}
                </IonRow>
              );
            })}
          </IonGrid>
        </IonContent>
      </IonPage>
    );
  };
}

const mapStateToProps = (state: any) => {
  return {
    getChild: PropTypes.func.isRequired,
    data: state.data
  }
}

const mapDispatchToProps = (dispatch: any) => {
  return {
    getChild: (fields: any, typeOptions: string) => dispatch(ResultActions.getChild(fields, typeOptions))
  }
};

export default connect(mapStateToProps, mapDispatchToProps)(Results);
